import $http from '../../shared/http';

export const positions = {
  namespaced: true,
  state: () => {
    return {
      positionsForSelect: null,
      positionData: null,
      existingPositionNames: null,
    };
  },
  getters: {
    getPositionsForSelect: (state) => {
      return state.positionsForSelect && state.positionsForSelect.length
        ? state.positionsForSelect.sort((a, b) => a.text.toUpperCase() - b.text.toUpperCase())
        : [];
    },
    getCurrentPosition: (state) => state.positionData,
    getExistingPositionNames: (state) => state.existingPositionNames,
  },
  mutations: {
    setPositionsForSelect: (state, payload) => (state.positionsForSelect = payload),
    setPositionData: (state, data) => {
      state.positionData = data;
    },
    setExistingPositionNames: (state, data) => {
      state.existingPositionNames = data;
    },
  },
  actions: {
    async LOAD_POSITIONS_FOR_SELECT({ commit }, { churchId }) {
      if (!churchId) {
        throw new Error('Church ID not provided');
      }
      return $http('v2')
        .get(`organisations/${churchId}/positions/select`, { canBeImpersonated: true })
        .then((response) => {
          commit('setPositionsForSelect', response.data.data);
          return response;
        });
    },

    async LOAD_POSITION_DATA({ commit }, { id, orgId }) {
      return await $http('v2')
        .get(`organisations/${orgId}/positions/${id}`)
        .then(async (response) => {
          commit('setPositionData', response.data.data);
          return response;
        });
    },

    async EDIT_POSITION(ctx, { form, orgId, id }) {
      return $http('v2').put(`organisations/${orgId}/positions/${id}`, form, { notifiable: true });
    },

    async CREATE_POSITION(ctx, { form, orgId }) {
      return $http('v2').post(`organisations/${orgId}/positions`, form, { notifiable: true });
    },

    async DELETE_POSITION(ctx, { id }) {
      return $http()
        .delete(`/positions/${id}`, { notifiable: true })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    async getPositionNamesAction({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        commit('setExistingPositionNames', null);
        await $http()
          .get(`/organisations/${churchId}/positions/check/names`, { canBeImpersonated: true })
          .then((response) => {
            commit('setExistingPositionNames', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
